import { FC, memo } from 'react';

import { icons } from '@assets/index';
import { ImgStyled } from '@components/common/Block/Img';
import { FormLabelHintStyled, FormLabelStyled } from '@components/common/FormStyled/FormStyled';
import { LabelMarkStyled } from '@components/common/Input/styled/InputStyled';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';

interface ICreateInquiryFieldLabel {
    name: string;
    prompt?: string;
    required?: boolean;
}

const CreateInquiryFieldLabel: FC<ICreateInquiryFieldLabel> = ({ name, required, prompt }) => {
    return (
        <FormLabelStyled style={{ display: 'flex' }}>
            {
                name
            }
            {
                required && <LabelMarkStyled>*</LabelMarkStyled>
            }
            {
                prompt && (
                    <FormLabelHintStyled>
                        <ArrowTooltip title={prompt}>
                            <ImgStyled className="small" src={icons.infoBlueIcon}/>
                        </ArrowTooltip>
                    </FormLabelHintStyled>
                )}
        </FormLabelStyled>
    );
};

export default memo(CreateInquiryFieldLabel);
